module.exports = __webpack_public_path__ + "static/media/barber-chair.b096ab1a.svg";